import { render, staticRenderFns } from "./NoBusiness.vue?vue&type=template&id=351095da"
import script from "./NoBusiness.vue?vue&type=script&lang=js"
export * from "./NoBusiness.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports